import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const UploadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Upload",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.63 16.69c.37-.48.59-1.08.59-1.74v-.03c0-1.68-1.37-3.05-3.05-3.05h-.18c-.68.03-1.29.29-1.77.7a6.747 6.747 0 0 0-13.43.95v.13c0 .42.05.83.13 1.23v-.04h-.77c-.42 0-.83.06-1.23.16h.03c-2.29.56-3.97 2.6-3.97 5.03s1.67 4.47 3.93 5.03h.04c.36.1.77.16 1.19.16h7.05v-5.66h-2.67a.87.87 0 0 1-.57-1.53s3.92-3.92 3.92-3.92c.16-.16.38-.26.62-.26s.46.1.62.26l3.92 3.92a.87.87 0 0 1-.57 1.53h-2.67v5.67h9.05c2.29-.08 4.12-1.95 4.12-4.26s-1.91-4.26-4.26-4.26h-.14l.03-.02Z"
    })
  }));
};